import { Col, Modal, Row, Spin, Typography } from 'antd';
import i18next from "i18next";
import { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { BorderBottomOutlined, BorderOuterOutlined } from '@ant-design/icons';
import { DraggableOnStart } from '../sgvmap/widgets/management/utils/DraggableOnStart';
import { EdrService } from '../../service/cartoService';
import { isMobile } from 'react-device-detect';
import { is } from 'date-fns/locale';


const { Title, Text } = Typography;

const VicaEDARAutocontroles = ({ setAutocontroles, nomEDAR, codEDAR, year, month }) => {

    const [showModalBody, setShowModalBody] = useState(true)
    const [isHoverMinimizeBt, setIsHoverMinimizeBt] = useState(false)


    const [disabled, setDisabled] = useState(false);
    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });

    const handleOk = (e) => {
        setAutocontroles(null);
    };

    const handleCancel = (e) => {
        setAutocontroles(null);
    };

    const draggleRef = useRef(null);

    const onStart = (_event, uiData) => {
        DraggableOnStart(_event, uiData, draggleRef, setBounds)
        _event.stopPropagation();
    };


    const expandStyle = {
        position: "absolute",
        fontSize: "18px",
        insetInlineEnd: "40px",
        zIndex: 1012,
        padding: 0,
        color: "rgba(0, 0, 0, 0.45)",
        cursor: "pointer",
        backgroundColor: isHoverMinimizeBt ? "#dee3ed" : "transparent"
    }

    function getModalWidth() {
        if (isMobile) {
            return "90%"
        }
        else {
            return "40%"
        }
    }

    return (
        <>
            <Modal style={{ float: "left", marginLeft: "10%" }}
                width={getModalWidth()}
                mask={isMobile}
                maskClosable={true}
                title={
                    <div
                        style={{
                            width: '100%',
                            cursor: 'move',
                        }}
                        onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false);
                            }
                        }}
                        onMouseOut={() => {
                            setDisabled(true);
                        }}
                        // fix eslintjsx-a11y/mouse-events-have-key-events
                        // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
                        onFocus={() => {
                        }}
                        onBlur={() => {
                        }}
                    // end
                    >
                        {"Autocontroles"}


                        {showModalBody && <BorderBottomOutlined
                            onMouseEnter={(e) => setIsHoverMinimizeBt(true)}
                            onMouseLeave={(e) => setIsHoverMinimizeBt(false)}
                            onClick={(e) => {
                                setShowModalBody(!showModalBody)
                            }}
                            style={expandStyle} />}
                        {!showModalBody && <BorderOuterOutlined
                            onMouseEnter={(e) => setIsHoverMinimizeBt(true)}
                            onMouseLeave={(e) => setIsHoverMinimizeBt(false)}
                            onClick={(e) => {
                                setShowModalBody(!showModalBody)
                            }}
                            style={expandStyle} />}

                    </div>

                }

                open={true}
                onOk={handleOk}
                onCancel={handleCancel}
                bodyStyle={{
                    maxHeight: window.innerHeight * 0.7,
                    overflow: "auto",
                    height: showModalBody ? "auto" : "0px"
                }}
                modalRender={(modal) => {
                    if (isMobile) {
                        return <div style={{ width: "100%", height: "100%" }}>{modal}</div>
                    }
                    else {
                        return <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                        >
                            <div ref={draggleRef}>{modal}</div>
                        </Draggable>
                    }

                }}
                footer={""
                    /*[
                       <Button id="flash" type="reset" onClick={() => flash()}><ThunderboltOutlined/></Button>,
                       <Button id="zoom" type="reset" onClick={() => zoom()}><ZoomInOutlined/></Button>
                   ]*/
                }
            >

                <Contenido nomEDAR={nomEDAR} codEDAR={codEDAR} year={year} month={month} />
            </Modal>
        </>
    );
}

export default VicaEDARAutocontroles;

const Contenido = ({ nomEDAR, codEDAR, year, month }) => {

    const [autocontroles, setAutocontroles] = useState();

    let rowStyle = { textAlign: "center", borderStyle: "solid", borderWidth: "1px", margin: "4px", borderColor: "rgba(0, 0, 0, 0.2)" }
    let cellStyle = { borderStyle: "solid", borderWidth: "1px", borderColor: "rgba(0, 0, 0, 0.1)" }

    let trimestre = "Trimestre 1";

    if (month == 6) trimestre = "Trimestre 2";
    else if (month == 9) trimestre = "Trimestre 3";
    else if (month == 12) trimestre = "Trimestre 4";

    useEffect(() => {
        EdrService.listEdarAutocontroles(codEDAR, year, month)
            .then((data) => {
                setAutocontroles(data);
            })
            .catch(err => {
                err.response.json().then(res => {
                    console.log("ERROR", res);
                });
            })
    }, [])


    let format2Number = (value) => {
        var vArr = (value + "").split(".");
        var v01 = vArr[0].toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
        v01 = v01.split('').reverse().join('').replace(/^[\.]/, '');
        if (v01[0] == ".") v01 = v01.substring(1);
        var v02 = "";
        if (vArr[1]) v02 = "," + vArr[1];
        return v01 + v02;
    };

    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";


        }

        let numAux = num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        return numAux.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };



    return (
        <div>
            <Row style={rowStyle}>
                <Col span={12} style={cellStyle}>
                    <Text strong >EDAR:</Text>
                </Col>
                <Col span={12} style={cellStyle}>
                    {nomEDAR}
                </Col>

                <Col span={12} style={cellStyle}>
                    <Text strong >AÑO - TRIMESTRE:</Text>
                </Col>
                <Col span={12} style={cellStyle}>
                    {year} - {trimestre}
                </Col>
            </Row>

            <Row style={rowStyle}>
                <Col span={12} style={cellStyle}>

                </Col>
                <Col span={12} style={cellStyle}>
                    <Text strong >CAUDAL VERTIDO <br />m³/d</Text>
                </Col>
                {autocontroles && autocontroles.autocontrolesCaudal.map((row) => {
                    return <>
                        <Col span={12} style={cellStyle}>
                            <Text strong >{row.mesLetra}</Text>
                        </Col>
                        <Col span={12} style={cellStyle}>
                            {formatNumber(row.caudal)}
                        </Col>
                    </>
                })}
            </Row>


            {!autocontroles && <Spin style={{ width: "100%" }} />}

            {autocontroles && autocontroles.autocontrolesDatos && autocontroles.autocontrolesDatos.length > 0 &&
                <>
                    <Row style={rowStyle}>
                        <Col style={cellStyle} span={24}>
                            <Text strong > PARÁMETROS ANALÍTICOS</Text>
                        </Col>

                        <Col style={cellStyle} span={3}>
                            <Text strong >Fecha <br /> Muestra</Text>
                        </Col>
                        <Col style={cellStyle} span={2}>
                            <Text strong >pH</Text>
                        </Col>
                        <Col style={cellStyle} span={3}>
                            <Text strong >Conduc. <br /> μS/cm</Text>
                        </Col>
                        <Col style={cellStyle} span={2}>
                            <Text strong >SS<br /> mg/L</Text>
                        </Col>
                        <Col style={cellStyle} span={2}>
                            <Text strong >DBO<sub>5</sub><br /> mg/L</Text>
                        </Col>
                        <Col style={cellStyle} span={3}>
                            <Text strong >DQO<br /> mg/L</Text>
                        </Col>
                        <Col style={cellStyle} span={3}>
                            <Text strong >Nt<br /> mg/L</Text>
                        </Col>
                        <Col style={cellStyle} span={3}>
                            <Text strong >Pt<br /> mg/L</Text>
                        </Col>
                        <Col style={cellStyle} span={3}>
                            <Text strong >ECAH</Text>
                        </Col>
                        {autocontroles.autocontrolesDatos.map((row) => {
                            return <>
                                <Col style={cellStyle} span={3}>
                                    {row.fecha}
                                </Col>
                                <Col style={cellStyle} span={2}>
                                    {format2Number(row.ph)}
                                </Col>
                                <Col style={cellStyle} span={3}>
                                    {format2Number(row.cond25)}
                                </Col>
                                <Col style={cellStyle} span={2}>
                                    {format2Number(row.mes)}
                                </Col>
                                <Col style={cellStyle} span={2}>
                                    {format2Number(row.dbo5)}
                                </Col>
                                <Col style={cellStyle} span={3}>
                                    {format2Number(row.dqoD)}
                                </Col>
                                <Col style={cellStyle} span={3}>
                                    {format2Number(row.nt)}
                                </Col>
                                <Col style={cellStyle} span={3}>
                                    {format2Number(row.ptot)}
                                </Col>
                                <Col style={cellStyle} span={3}>
                                    {row.laboratorio}
                                </Col>
                            </>
                        })}
                    </Row>
                </>
            }

            {/*autocontroles && autocontroles.terciariosDatos && autocontroles.terciariosDatos.length > 0 &&

                <Row style={rowStyle}>
                    <Col style={cellStyle} span={4}>
                        <Text strong >Fecha <br /> Muestra</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >SS <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Turbidez <br /> N.T.U.</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Nemátodos int<br /> Huevos/10L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Legionella<br /> μfc/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >E.Coli<br /> μfc/100 mL </Text>
                    </Col>
                    <Col style={cellStyle} span={5}>
                        <Text strong >ECAH </Text>
                    </Col>
                    {autocontroles.terciariosDatos.map((row) => {
                        return <>
                            <Col style={cellStyle} span={4}>
                                {row.fecha}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.ss)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.turbidez)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.nematodos)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.legionela)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.ecoli)}
                            </Col>
                            <Col style={cellStyle} span={5}>
                                {row.laboratorio}
                            </Col>
                        </>
                    })}
                </Row>*/
            }

            {autocontroles && autocontroles.adicionalesDatos && autocontroles.adicionalesDatos.length > 0 &&

                <Row style={rowStyle}>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Fecha <br /> Muestra</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Aceites y Grasas <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={2}>
                        <Text strong >Cloruros <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={2}>
                        <Text strong >Floruros <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={2}>
                        <Text strong >Niquel <br /> μg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Cinc <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Cromo <br /> μg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >Sulfuros <br /> mg/L</Text>
                    </Col>
                    <Col style={cellStyle} span={3}>
                        <Text strong >ECAH</Text>
                    </Col>
                    {autocontroles.adicionalesDatos.map((row) => {
                        return <>
                            <Col style={cellStyle} span={3}>
                                {row.fecha}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.aceitesygrasas)}
                            </Col>
                            <Col style={cellStyle} span={2}>
                                {format2Number(row.cloruro)}
                            </Col>
                            <Col style={cellStyle} span={2}>
                                {format2Number(row.floruro)}
                            </Col>
                            <Col style={cellStyle} span={2}>
                                {format2Number(row.niquel)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.cinc)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.cromo)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {format2Number(row.sulfuros)}
                            </Col>
                            <Col style={cellStyle} span={3}>
                                {row.laboratorio}
                            </Col>
                        </>
                    })}
                </Row>
            }

        </div>
    )
}